import katex from "katex";
import "katex/dist/katex.min.css";

window.katex = katex;
